import axios from "axios";
import jwtDecode from "jwt-decode";
const fetchPermissions = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_BASE_URL}permissions/`,
      { withCredentials: true }
    );
    const permissions = response.data.permissions || [];
    console.log("Fetched permissions from API", response);
    return permissions;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    return [];
  }
};
const isTokenExpired = () => {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return !exp || exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
};
const userdetails =
  JSON.parse(sessionStorage.getItem("user")) ||
  JSON.parse(localStorage.getItem("user")) ||
  null;
const userRole = userdetails ? userdetails.role : null;
const authChannel = new BroadcastChannel("auth");

const user = {
  state: {
    userPermissions: fetchPermissions(),
    userdetails: userdetails,
    userRole: userRole,
    unreadNotificationCount: 0,
    isVisibleEditMode: false,
    isDivVisible: false,
    isTokenExpired: isTokenExpired(),
  },

  mutations: {
    SET_UNREAD_NOTIFICATION_COUNT(state, count) {
      state.unreadNotificationCount = count;
    },
    toggleVisibility(state) {
      state.isVisibleEditMode = !state.isVisibleEditMode;
    },
    toggleDivVisibility(state) {
      state.isDivVisible = !state.isDivVisible;
      console.log("Div visibility toggled:", state.isDivVisible);
    },
    setuserDetails(state, payload) {
      state.userdetails = payload;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    setUserPermissions(state, permissions) {
      state.userPermissions = permissions;
      console.log("setUserPermissions mutation", state.userPermissions);
    },
    resetState(state) {
      state.userPermissions = [];
      state.userdetails = null;
      state.userRole = null;
      state.unreadNotificationCount = 0;
      state.isVisibleEditMode = false;
      state.isDivVisible = false;
    },
  },

  actions: {
    updateUnreadNotificationCount({ commit }, count) {
      commit("SET_UNREAD_NOTIFICATION_COUNT", count);
    },

    toggleDiv({ commit }) {
      console.log("Toggling div visibility...");
      commit("toggleDivVisibility");
    },

    async fetchPermissions({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}permissions/`,
          { withCredentials: true }
        );
        const permissions = response.data.permissions || [];
        console.log("Fetched permissions from API", response);
        commit("setUserPermissions", permissions);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    },

    setUserRoleAndFetchPermissions({ commit, dispatch }, role) {
      console.log("Setting user role and fetching permissions:", role);
      if (role) {
        commit("setUserRole", role);
      }
      dispatch("fetchPermissions");
    },

    isTokenExpired({ state }) {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      if (!token) state.isTokenExpired = true;
      try {
        const { exp } = jwtDecode(token);
        state.isTokenExpired = !exp || exp < Math.floor(Date.now() / 1000);
      } catch {
        state.isTokenExpired = true;
      }
    },

    async logout({ commit }) {
      try {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("paymentStatus");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("paymentStatus");
        authChannel.postMessage({ type: "LOGOUT" });
        window.location.href = "/";
        commit("resetState");
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },

    initializeAuthListener({ commit }) {
      authChannel.onmessage = async (event) => {
        console.log("Received auth channel message:", event.data);
        if (event.data.type === "LOGOUT") {
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("paymentStatus");
          sessionStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          localStorage.removeItem("paymentStatus");
          window.location.href = "/";
          commit("resetState");
        }
      };
    },
  },

  getters: {
    unreadNotificationCount: (state) => state.unreadNotificationCount,
    hasuserdetails: (state) => state.userdetails,
    getUserRole: (state) => state.userRole,
    getUserPermissions: (state) => state.userPermissions,
    isDivVisible: (state) => state.isDivVisible,
    isTokenExpired: (state) => state.isTokenExpired,
  },
};

export default user;
